import {
  Box,
  Container,
  Paper,
  Typography,
  Alert,
  Button,
} from "@mui/material";
import { HourglassEmpty, Email, CheckCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function SignupPending() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ mt: 8, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: "center" }}>
        <HourglassEmpty sx={{ fontSize: 80, color: "warning.main", mb: 2 }} />

        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Application Pending
        </Typography>

        <Typography color="text.secondary" paragraph sx={{ mb: 3 }}>
          Thank you for applying to join NephroTrax!
        </Typography>

        <Alert
          severity="info"
          icon={<Email />}
          sx={{ mb: 3, textAlign: "left" }}
        >
          <Typography variant="body2" gutterBottom>
            <strong>What happens next:</strong>
          </Typography>
          <Box component="ul" sx={{ pl: 2, mt: 1, mb: 0 }}>
            <li>Our team will verify your credentials</li>
            <li>You'll receive an email within 24-48 hours</li>
            <li>Once approved, you can login and access the platform</li>
          </Box>
        </Alert>

        <Box
          sx={{
            bgcolor: "rgba(102, 126, 234, 0.08)",
            p: 2,
            borderRadius: 2,
            mb: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <CheckCircle sx={{ color: "success.main", fontSize: 20 }} />
            <Typography variant="body2" fontWeight="bold">
              Verification Process
            </Typography>
          </Box>
          <Typography variant="caption" color="text.secondary" display="block">
            We verify all healthcare providers and researchers to maintain the
            security and integrity of patient data on our platform.
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" paragraph>
          Questions? Contact us at{" "}
          <a href="mailto:sandeep.sinha@verainsight.com">
            sandeep.sinha@verainsight.com
          </a>
        </Typography>

        <Button
          variant="contained"
          onClick={() => navigate("/")}
          sx={{ mt: 2 }}
        >
          Return to Home
        </Button>
      </Paper>
    </Container>
  );
}
